import React from 'react'
import Badge from '../Badge'

export const actionStatusColorMap = {
  "default": "yellow",
  "In Progress": "yellow",
  "Late": "red",
  "Cancelled": "red",
  "Completed": "green",
}

const ActionStatusBadge = ({
  type,
  tooltip,
}) => {
  return <Badge
    value={type}
    tooltipText={tooltip}
    colorName={actionStatusColorMap[type] || actionStatusColorMap["default"]}
  />
}

export default ActionStatusBadge